import { render } from "./UpdatingSystem.vue?vue&type=template&id=310098a6&scoped=true&ts=true"
import script from "./UpdatingSystem.vue?vue&type=script&lang=ts"
export * from "./UpdatingSystem.vue?vue&type=script&lang=ts"

import "./UpdatingSystem.vue?vue&type=style&index=0&id=310098a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310098a6"]])

export default __exports__